function applyFeaturedFix(root = document) {
  // alle Produkt-Galerien mit data-first-variant-media
  const galleries = root.querySelectorAll(
    ".product-media--variants--root[data-first-variant-media]"
  );
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const featuredId = gallery.getAttribute("data-first-variant-media");
    if (!featuredId) return;

    const mediaItems = gallery.querySelectorAll(".product-media--root");
    if (!mediaItems.length) return;

    let featuredEl = null;

    mediaItems.forEach((el) => {
      if (el.dataset.id === featuredId) {
        featuredEl = el;
      }
      // alles erstmal deaktivieren
      el.dataset.active = "false";
    });

    if (!featuredEl) return;

    featuredEl.dataset.active = "true";

    const parent = featuredEl.parentNode;
    if (!parent) return;

    // Featured als erstes Element im Container einhängen
    const firstElement = parent.firstElementChild;
    if (firstElement !== featuredEl) {
      parent.insertBefore(featuredEl, firstElement || null);
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  applyFeaturedFix();

  // zur Sicherheit noch einmal etwas später ausführen,
  // falls das Theme-JS später initialisiert
  setTimeout(applyFeaturedFix, 300);
  setTimeout(applyFeaturedFix, 1000);
});

window.addEventListener("load", () => {
  applyFeaturedFix();
});

// wenn im Theme eine Sektion neu geladen wird (Customizer oder AJAX)
document.addEventListener("shopify:section:load", (event) => {
  applyFeaturedFix(event.target);
});

// Fallback: Observer reagiert auf DOM-Änderungen (z. B. Variantenwechsel)
const observer = new MutationObserver(() => {
  applyFeaturedFix();
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
